<template>
    <div>
        <div class="heading">Terms Of Service</div>
        <p>Effective Date: August 3rd, 2026</p>
        <p>Welcome to Vocation ("the Platform"). These Terms of Service ("Terms") govern your access to and use of the website located at vocation.mw, the Vocation CV Builder, and any related recruitment or job-search services (collectively, the "Service") operated by {{company_name}} ("us", "we", or "our").</p>
        
        <p>By creating an account, accessing, or using the Service, you agree to be bound by these Terms. If you disagree with any part of these terms, you do not have permission to access the Service.</p>
        
        <div class="policy-heading">1. Eligibility and Accounts</div>
        <ul>
            <li class="policy-item">Age Requirement: You must be at least 18 years old (or the legal age of majority in Malawi) to create an account.</li>
            <li class="policy-item">Accuracy: You guarantee that all information provided during registration—and within Vocation's CV Builder—is accurate, current, and truthful.</li>
            <li class="policy-item">Security: You are entirely responsible for safeguarding your login credentials. You must notify us immediately at privacy@vocation.mw if you suspect unauthorized access to your account.</li>
        </ul>
        
        <div class="policy-heading">2. The Service and Data Integration</div>
        <ul>
            <li class="policy-item">Purpose: {{company_name}} provides job-search, profile visibility, and resume-building utilities.</li>
            <li class="policy-item">Privacy Alignment: Your usage of this Platform is simultaneously governed by the {{company_name}} Privacy Policy. Data processed through your account registration and CV Builder inputs (including names, contact records, history, and certificates) is handled in strict compliance with Malawi's Data Protection Act, 2023.</li>
            <li class="policy-item">Visibility Settings: By utilizing the platform, you acknowledge that your profile and resume data will be shared with Employers and Recruiters in direct alignment with the custom visibility configurations you select.</li>
        </ul>
        
        <div class="policy-heading">3. Prohibited Conduct and Platform Misuse</div>
        <p>You agree not to engage in any of the following prohibited behaviors:</p>
        <ul>
            <li class="policy-item">Fraudulent Details: Creating false identities, misleading career summaries, or impersonating other individuals or entities.</li>
            <li class="policy-item">Scraping and Mining: Using automated bots, scripts, spiders, or scrapers to extract recruiter data, job postings, or user profiles without explicit written permission.</li>
            <li class="policy-item">System Abuse: Transmitting malicious code, spamming platform users, or attempting to compromise the infrastructure stability of our secure servers.</li>
        </ul>
        
        <div class="policy-heading">4. Intellectual Property Rights</div>
        <ul>
            <li class="policy-item">Vocation Ownership: The Service's core code, interface design, branding, and original content remain the exclusive property of {{company_name}}.</li>
            <li class="policy-item">User Content License: By inputting data into Vocation's CV Builder or profile portal, you grant {{company_name}} a limited, non-exclusive, royalty-free license to host, format, and display your data solely to execute your preferred job-search services and employer visibility settings.</li>
        </ul>
        
        <div class="policy-heading">5. Account Lifecycle: Inactivity and Dormancy</div>
        <p>In alignment with our legal storage limitation obligations:</p>
        <ul>
            <li class="policy-item">12-Month Inactivity: Accounts with no login activity for 12 continuous months will be flagged for protective cleanup.</li>
            <li class="policy-item">90-Day Notification Window: At the very end of the 12 months, we will issue an automated notice to your registered email giving you ninety (90) days to log in and preserve your account.</li>
            <li class="policy-item">Permanent Erasure: Failure to log in within the 90 days will have the account permanently anonymized and destroyed.</li>
        </ul>
        
        <div class="policy-heading">6. Suspension, Termination, and Abuse Enforcement</div>
        <ul>
            <li class="policy-item">Right to Terminate: {{company_name}} reserves the absolute right to suspend or terminate accounts that breach these Terms, commit fraud, or threaten platform safety.</li>
            <li class="policy-item">Exemption from Erasure: Accounts terminated or suspended due to platform abuse or security violations are explicitly exempt from our automated erasure and anonymization lifecycles.</li>
            <li class="policy-item">Data Retention for Security: Essential identifying indicators and system audit logs from banned accounts will be securely retained long-term. This is strictly maintained to enforce platform bans, protect our user community, and comply with law enforcement or judicial requests under Malawian law.</li>
        </ul>
        
        <div class="policy-heading">7. Limitation of Liability and "As-Is" Clause</div>
        <ul>
            <li class="policy-item">Platform Availability: The Service is provided on an "AS IS" and "AS AVAILABLE" basis. {{company_name}} does not guarantee that the platform will be uninterrupted or entirely error-free.</li>
            <li class="policy-item">Employment Outcomes: {{company_name}} is a job-search infrastructure provider. We do not guarantee employment, interviews, or the legitimacy of third-party hiring decisions.</li>
            <li class="policy-item">Liability Cap: To the maximum extent permitted under Malawian law, {{company_name}} shall not be liable for any indirect, incidental, or consequential damages resulting from your use or inability to use the platform.</li>
        </ul>
        
        <div class="policy-heading">8. Governing Law and Regulatory Oversight</div>
        <ul>
            <li class="policy-item">Jurisdiction: These Terms shall be governed, construed, and enforced in accordance with the laws of the Republic of Malawi.</li>
            <li class="policy-item">Regulatory Compliance: Platform operations and structural data obligations remain under the regulatory oversight of the Malawi Communications Regulatory Authority (MACRA).</li>
        </ul>
        
        <div class="policy-heading">9. Modifications to Terms</div>
        <p>We reserve the right to modify these Terms to match platform upgrades or changing Malawian legal frameworks. If we introduce material changes that alter your user obligations, we will actively notify you via your registered email address or through a prominent notice on your Vocation platform dashboard before the updates take effect.</p>
        
        <div class="policy-heading">10. Contact and Inquiries</div>
        <p>For any questions regarding these Terms, or to report a violation by another platform user, contact us at:</p>
        <ul>
            <li class="policy-item">Email: privacy@vocation.mw</li>
        </ul>
    </div>
</template>

<script>
export default {
    data(){
        return{
            company_name: process.env.VUE_APP_OFFICIAL_COMPANY_NAME,
            privacy_email: process.env.VUE_APP_PRVACY_EMAIL
        }
    }
}
</script>

<style scoped>
        .heading, p, li{
        font-family: var(--body-font);
    }


    .heading{
        margin-top:-1rem;
        color:var(--intro);
        margin-bottom:1.2rem;
        font-size:3.2rem;
        font-family: var(--page-header-font);
         
    }

    .policy-heading{
        color:var(--intro);
        margin-bottom:0.9rem;
        font-size:1.5rem;
    }

    @media(max-width: 768px){
        .heading{
            margin-top:0rem;
            font-size:2rem;
             margin-bottom:0.8rem;
        }

        .policy-heading{
          font-size:1rem;
        }

        p{
          font-size:0.9rem;
        }
    }
</style>
